import React from 'react';

const DashboardFooter = () => {
    return (
        <div style={{ textAlign: 'center', marginTop: '50px', marginBottom: '20px', color: '#888', fontSize: '12px' }}>
            <div style={{ marginBottom: '5px', fontWeight: '500', color: '#555' }}>Serving trust in jewellery since 1995</div>
            <div>Handcrafted • BIS Hallmarked • India 🇮🇳</div>
        </div>
    );
};

export default DashboardFooter;
